/** Normalizes AppSync `onWaveOps` subscription payloads (shape varies by transport). */
export function extractWaveOpsFromSubscriptionPayload(data) {
    if (!data || typeof data !== "object")
        return [];
    const record = data;
    if (Array.isArray(record.ops)) {
        return record.ops;
    }
    const nested = record.onWaveOps;
    if (nested && typeof nested === "object") {
        const batch = nested;
        if (Array.isArray(batch.ops))
            return batch.ops;
    }
    return [];
}
/** Reads `nextOpSeq` from an `onWaveOps` subscription payload when present. */
export function extractNextOpSeqFromSubscriptionPayload(data) {
    if (!data || typeof data !== "object")
        return null;
    const record = data;
    const read = (obj) => {
        const raw = obj.nextOpSeq;
        if (typeof raw === "number" && Number.isFinite(raw) && raw > 0)
            return raw;
        return null;
    };
    const direct = read(record);
    if (direct != null)
        return direct;
    const nested = record.onWaveOps;
    if (nested && typeof nested === "object") {
        return read(nested);
    }
    return null;
}
